import { gql } from '@apollo/client';

export const INSERT_STUDENT_REQUEST_MESSAGE = gql`
  mutation insert_student_request_message($objects: [student_request_message_insert_input!]!) {
    insert_student_request_message(objects: $objects) {
      affected_rows
    }
  }
`;

export const STUDENT_REQUEST_MESSAGES = gql`
  subscription student_request_message(
    $where: student_request_message_bool_exp
    $order_by: [student_request_message_order_by!]
  ) {
    student_request_message(where: $where, order_by: $order_by) {
      id
      userId
      user_public {
        firstName
      }
      studentId
      student {
        firstName
      }
      content
    }
  }
`;
